import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'research-advisor'
const Actions = crudActions(endpoint)

const searchAdvisor = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/advisors/`, { params: queryParams })
    .then(response => {
      const res = response.data
      commit('ADVISOR', (Array.isArray(res) && res.length > 0) ? res[0] : null)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const orgAdvisors = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/org_advisors/`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const createAdvisor = (ctx, data) => new Promise((resolve, reject) => {
  axios.post(`/${endpoint}/create_advisor/`, data.user)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const update = (ctx, data) => new Promise((resolve, reject) => {
  axios.put(`/${endpoint}/${data.id}/update_advisor/`, data.user)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const addStudent = (ctx, data) => new Promise((resolve, reject) => {
  axios.patch('/apply-document/change_advisor_student/', data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const updateStudent = (ctx, { id, advisor_id }) => axios.patch(`apply-document/${id}/change_advisor_of_student/`, { advisor_id })
const delStudent = (ctx, data) => new Promise((resolve, reject) => {
  axios.delete(`/apply-document/${data.id}/removed_student_from_advisor/?advisor_id=${data.advisorId}`)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const students = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/apply-document/unmerged_students/', { params: queryParams })
    .then(response => {
      commit('STUDENTS', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
export default {
  ...Actions,
  searchAdvisor,
  orgAdvisors,
  createAdvisor,
  students,
  addStudent,
  update,
  delStudent,
  updateStudent,
}
